import moment from "moment";

const formatDate = (date: string) => {
  if (!date) return "";
  try {
    // Parse as UTC and display without timezone conversion
    return moment.utc(date).format("DD MMM YYYY, hh:mm A");
  } catch (e) {
    console.error("Error formatting date:", e);
    return "";
  }
};

export { formatDate };